import config from '../config';

// Short-link domains must be ones only Lashbrook can create links on, since the redirect target isn't checked.
const PRODUCTION_HOSTS = ['www.helzberg.com', 'lashbrook.link'];
const STAGING_HOSTS = ['bhdw-005.dx.commercecloud.salesforce.com', 'bhdw-005.my.commercecloud.salesforce.com'];

// Only staging builds approve the staging store, so production kiosks can never be sent to a staging QR code.
export const qrScannerAllowedHosts = () => {
  const isStaging = (process.env.REACT_APP_API_BASE_URL || '').includes('staging');
  return isStaging ? [...PRODUCTION_HOSTS, ...STAGING_HOSTS] : PRODUCTION_HOSTS;
};

// CloudFront environment settings arrive as strings, so lists may be comma-separated.
const settingList = (value: unknown): string[] => {
  if (Array.isArray(value)) return value.map(String);
  if (typeof value === 'string')
    return value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  return [];
};

export const qrScannerEnabled = () => config.qrScannerEnabled !== false && config.qrScannerEnabled !== 'false';

export const qrScannerParentOrigins = () => settingList(config.qrScannerParentOrigins);

export const approvedScanUrl = (text: string, allowedHosts: string[], allowedPaths: RegExp[] = []) => {
  let url: URL;
  try {
    url = new URL(text.trim());
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  if (url.username || url.password) return null;
  if (!allowedHosts.includes(url.hostname.toLowerCase())) return null;
  if (allowedPaths.length && !allowedPaths.some((pattern) => pattern.test(url.pathname))) return null;
  return url;
};
